import * as form from '../form';

export const historyResidence = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Dates: form.daterange(xitem.Dates), // Used in PVQ and SF8X
        Address: form.location(xitem.Address), // Used in PVQ and SF8X
        IsTemporaryAddress: form.branch(xitem.IsTemporaryAddress), // PVQ Only
        TemporaryAddressPurpose: form.radio(xitem.TemporaryAddressPurpose), // PVQ Only
        TemporaryAddressPurposeExplanation: form.textarea(xitem.TemporaryAddressPurposeExplanation), // PVQ Only
        AlternateAddress: form.physicaladdress(xitem.AlternateAddress),
        Comments: form.textarea(xitem.Comments),
        ReferenceName: form.name(xitem.ReferenceName),
        ReferenceName2013: form.text(xitem.ReferenceName2013),
        ReferenceLastContact: form.datecontrol(xitem.ReferenceLastContact),
        ReferenceRelationshipComments: form.checkboxgroup(xitem.ReferenceRelationshipComments),
        ReferenceRelationship: form.checkboxgroup(xitem.ReferenceRelationship),
        ReferenceRelationshipOther: form.text(xitem.ReferenceRelationshipOther),
        ReferencePhoneEvening: form.telephone(xitem.ReferencePhoneEvening),
        ReferencePhoneDay: form.telephone(xitem.ReferencePhoneDay),
        ReferencePhoneMobile: form.telephone(xitem.ReferencePhoneMobile),
        ReferenceEmailNotApplicable: form.notapplicable(xitem.ReferenceEmailNotApplicable),
        ReferenceEmail: form.email(xitem.ReferenceEmail),
        ReferenceAddress: form.location(xitem.ReferenceAddress),
        ReferenceAlternateAddress: form.physicaladdress(xitem.ReferenceAlternateAddress),
        Role: form.radio(xitem.Role),
        RoleOther: form.text(xitem.RoleOther),
        AddressPhysicalComments: form.textarea(xitem.AddressPhysicalComments),
        AddressComments: form.textarea(xitem.AddressComments),
        AddressAnswerComments: form.textarea(xitem.AddressAnswerComments),
        ReferenceComments: form.textarea(xitem.ReferenceComments),
        ReferenceAlternateAddressPhysicalComments: form.textarea(xitem.ReferenceAlternateAddressPhysicalComments),
        ReferenceAlternateAddressAnswerComments: form.textarea(xitem.ReferenceAlternateAddressAnswerComments),
        ReferenceAlternateAddressComments: form.textarea(xitem.ReferenceAlternateAddressComments),
      },
    };
  });

  return {
    Comments: form.textarea(data.Comments),
    List: form.collection(items, (data.List || {}).branch),
  };
};
